import { render, staticRenderFns } from "./Doctors.template.vue?vue&type=template&id=1fdff66d&scoped=true&"
var script = {}
import style0 from "./Doctors.template.vue?vue&type=style&index=0&id=1fdff66d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdff66d",
  null
  
)

export default component.exports